class NotificationFeedbackService {
  constructor(client) {
    this.apiClient = client;
  }

  getSettings() {
    return this.apiClient.get("releasenotessettings");
  }
}

export default NotificationFeedbackService;
